import apiClient from '../utils/apiClient';

class RestaurantService {
    // Get all restaurants (for owners)
    async getRestaurants() {
        const response = await apiClient.get('/restaurants');
        return response;
    }

    // Get single restaurant
    async getRestaurant(id) {
        const response = await apiClient.get(`/restaurants/${id}`);
        return response;
    }

    // Create new restaurant
    async createRestaurant(restaurantData) {
        const response = await apiClient.post('/restaurants', restaurantData);
        return response;
    }

    // Update restaurant
    async updateRestaurant(id, restaurantData) {
        const response = await apiClient.patch(`/restaurants/${id}`, restaurantData);
        return response;
    }

    // Delete restaurant
    async deleteRestaurant(id) {
        const response = await apiClient.delete(`/restaurants/${id}`);
        return response;
    }

    // Upload restaurant image
    async uploadRestaurantImage(id, file) {
        const response = await apiClient.uploadFile(`/restaurants/${id}/image`, file);
        return response;
    }

    // Get restaurant analytics (unified endpoint - returns stats, insights, and performance)
    async getRestaurantAnalytics(id, period = 'month') {
        const response = await apiClient.get(`/restaurants/${id}/analytics?period=${period}`);
        return response;
    }

    // Get GST reports for a date range
    async getGstReports(id, from, to) {
        const response = await apiClient.get(`/restaurants/${id}/gst-reports?from=${from}&to=${to}`);
        return response;
    }

    // Search restaurants
    async searchRestaurants(query, filters = {}) {
        const searchParams = { q: query, ...filters };
        const queryString = new URLSearchParams(searchParams).toString();
        const response = await apiClient.get(`/restaurants/search?${queryString}`);
        return response;
    }
}

const restaurantService = new RestaurantService();
export default restaurantService;
